const newUnit = {
  snackbar: "Ihr Update ist fertig",
  name: "Einheitenname",
  save: "speichern",
  cancel: "Stornieren",
  area: "Bereich",
  formTitle: "Neue Einheit",
  confirm: "Möchten Sie diesen Artikel wirklich löschen?",
  close: "Schließen",
  delete: "Löschen"
};
export default newUnit;
